export const LEAF_BUTTON_FORMAT = {
  STRIKE_THROUGH: "strikethrough",
  ITALIC: "italic",
  BOLD: "bold",
  UNDERLINE: "underline",
} as const;

export type LeafButtonFormatType =
  (typeof LEAF_BUTTON_FORMAT)[keyof typeof LEAF_BUTTON_FORMAT];

export const BLOCK_BUTTON_FORMAT = {
  NUMBERED_LIST: "numbered-list",
  BULLETED_LIST: "bulleted-list",
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
} as const;

export type BlockButtonFormatType =
  (typeof BLOCK_BUTTON_FORMAT)[keyof typeof BLOCK_BUTTON_FORMAT];
